import { QueryKeys } from "@coworker/app/src/components/RoomSettings/hooks/queryKeys";
import { QueryClient } from "@tanstack/react-query";
import { NotificationBase } from "../types/notification.types";

export const updateQueryCache = (
  queryClient: QueryClient,
  userId: string,
  notification: NotificationBase,
  maxNotificationsCount?: number
) => {
  queryClient.setQueryData(
    [QueryKeys.MessageNotifications, { id: userId }],
    (oldNotifications: NotificationBase[]) => {
      const newNotifications: NotificationBase[] = [];
      let addNotification = true;
      if (oldNotifications) {
        for (const oldNotification of oldNotifications) {
          if (oldNotification.id === notification.id) {
            newNotifications.push(notification);
            addNotification = false;
          } else {
            newNotifications.push(oldNotification);
          }
        }
      }

      // Insert in createdAt order
      if (addNotification) {
        for (let idx = 0; idx < newNotifications.length; idx++) {
          if (
            new Date(notification.createdAt).getTime() >
            new Date(newNotifications[idx]!.createdAt).getTime()
          ) {
            newNotifications.splice(idx, 0, notification);
            addNotification = false;
            break;
          }
        }
      }

      // Add last
      if (addNotification) {
        newNotifications.push(notification);
      }

      if (maxNotificationsCount) {
        return newNotifications.slice(0, maxNotificationsCount);
      } else {
        return newNotifications;
      }
    }
  );
};
